import axios from 'axios'
import { Notify } from 'quasar'

const axiosInstance = axios.create({
  baseURL: process.env.API
})

axiosInstance.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (!error.response) {
    Notify.create('Erro de rede')
  }
  return Promise.reject(error)
})

export default ({ Vue }) => {
  Vue.prototype.$axios = axiosInstance
  Vue.axios = Vue.prototype.$axios
}

export { axiosInstance }
